/**
 * Blaze configuration
 * @param {int} columns Columns att.
 * @returns {object}
 */
export const blazeConfig = (columns) => {
    return {
        all: {
            loop: true,
            enablePagination: false,
            slidesToScroll: 1,
            slidesToShow: 1,
        },
        '(min-width:767px)': {
            slidesToShow: 2,
            slidesToScroll: 1,
        },
        '(min-width:1199px)': {
            slidesToShow: 3,
            slidesToScroll: 1,
        },
        '(min-width:1399px)': {
            slidesToShow: columns,
            slidesToScroll: 1,
        },
    };
};

export const blazeConfigCategories = (sliderBreakpoints) => {
    return {
        all: {
            loop: true,
            enablePagination: false,
            slidesToScroll: 1,
            slidesToShow: sliderBreakpoints.breakpoint_sm,
        },
        '(min-width:768px)': {
            slidesToShow: sliderBreakpoints.breakpoint_md,
            slidesToScroll: 1,
        },
        '(min-width:991px)': {
            slidesToShow: sliderBreakpoints.breakpoint_lg,
            slidesToScroll: 1,
        },
        '(min-width:1199px)': {
            slidesToShow: sliderBreakpoints.breakpoint_xl,
            slidesToScroll: 1,
        },
        '(min-width:1399px)': {
            slidesToShow: sliderBreakpoints.breakpoint_xxl,
            slidesToScroll: 1,
        },
    };
};

export const blazeConfigVariants = () => {
    return {
        all: {
            loop: true,
            enablePagination: false,
            slidesToScroll: 1,
            slidesToShow: 1,
        },
        // '(min-width:376px)': {
        //     slidesToShow: 2,
        //     slidesToScroll: 1,
        // },
        // '(min-width:1199px)': {
        //     slidesToShow: 4,
        //     slidesToScroll: 1,
        // },
        // '(min-width:1399px)': {
        //     slidesToShow: 5,
        //     slidesToScroll: 1,
        // },
        // '(min-width:1699px)': {
        //     slidesToShow: 6,
        //     slidesToScroll: 1,
        // },
    };
};

export const blazeConfigSpecials = (columns) => {
    let sliderConfig = '';

    switch (columns) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 6:
            sliderConfig = {
                all: {
                    loop: true,
                    enablePagination: false,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
                '(min-width:767px)': {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
                '(min-width:1199px)': {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
                '(min-width:1399px)': {
                    slidesToShow: columns,
                    slidesToScroll: 1,
                },
            };
            break;
        case 2:
            sliderConfig = {
                all: {
                    loop: true,
                    enablePagination: false,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
                '(min-width:767px)': {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            };
            break;
        case null:
        case undefined:
            sliderConfig = {
                all: {
                    loop: true,
                    enablePagination: false,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
                '(min-width:767px)': {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
                '(min-width:1199px)': {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            };
            break;
        default:
            sliderConfig = {
                all: {
                    loop: true,
                    enablePagination: false,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
                '(min-width:767px)': {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
                '(min-width:1199px)': {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            };
            break;
    }

    return sliderConfig;
};

export const blazeConfigMenuBanners = () => {
    return {
        all: {
            loop: true,
            enablePagination: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            enableAutoplay: true,
            stopAutoplayOnInteraction: true,
            autoplayInterval: 5000,
        },
    };
};

export const filterTypes = {
    category: 'category',
    subcategory: 'subcategory',
    brands: 'brandIds',
    effects: 'effects',
    weights: 'weights',
    strain: 'strainType',
    potencyThc: 'potencyThc',
    potencyCbd: 'potencyCbd',
    custom: 'CUSTOM_SECTION',
    specials: 'specials',
    staff_picks: 'staff_picks',
    search: 'search',
    price: 'price',
    tags: 'tags',
};

export const defaultSort = { sortDir: 'DESC', sortKey: 'POPULAR' };

export const storageItemName =
    window.location.hostname.replace('.', '_').toUpperCase() +
    '_RANGE_HEADLESS';

/**
 * List of accepted :categoryType params that when appearing as the :locationSlug param will redirect to saved retailer.
 * `shop/brand/brand-name` -> `shop/location-slug/brand/brand-name`
 */
export const categoryTypes = [
    'brand',
    'category',
    'special',
    'specials',
    'tags',
    'effect',
    'subcategory',
];
